import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getOrbitDetails, setHeader } from "../../../../feature/orbit-slice";
import { useMutation } from "@tanstack/react-query";
import planetService from "../../services/planet-service";
import { orbitParamValue } from "../../../../utils/helper";
import { useSearchParams } from "react-router-dom";
import SyOverlayContainer from "../../../../shared/components/sy-overlay-container";
import PlanetManage from "./planet-manage";

type Props = {}

const PlanetScreen = (props: Props) => {
  const [openPlanetManage, setOpenPlanetManage] = useState<boolean>(true);
  const [planetStatus, setPlanetStatus] = useState<any>([]);

  const onClose =()=>{
    setOpenPlanetManage(false)
    dispatch(setHeader(true));
    setTimeout(() => {
      navigate(-1);
    }, 500);
  }

  const [addOrbitPopup, setAddOrbitPopup] = useState<boolean>(true);
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const [params, setParams] = useState<any>(orbitParamValue(searchParams));
  const orbitInfo = useSelector(getOrbitDetails);

  const onClickCloseOrbit =()=>{
    dispatch(setHeader(true));
    setAddOrbitPopup(false);
   
    setTimeout(() => {
      navigate(-1);
    }, 500);
  }

  const { mutate: getPlanetStatus } = useMutation({
    mutationFn: planetService.getPlanetStatus,
    onSuccess(data, variables, context) {
      setPlanetStatus(data.data)
 
    },
  });
   useEffect(() => {
    getPlanetStatus()
    dispatch(setHeader(false))
   },[])

   
  return (
    <div className=" " onClick={onClose}>
    <div className="position-absolute bottom-0 px-4 w-100 "  onClick={(e) => e.stopPropagation()} >
    <SyOverlayContainer open={openPlanetManage} height="full" >
    {planetStatus.length &&
      <PlanetManage close={onClose} planetStatus={planetStatus}/>
    }
    </SyOverlayContainer>


  </div>
  </div>
  )
}

export default PlanetScreen